<template>
    <div clsss="gaming-place card">
        <transition>
            <div class="game-not-started" v-if="!gameIsRunning">
                <button @click="startGame(500)">
                    <span v-if="!lastGameScore">
                        <font-awesome-icon :icon="['fas', 'play']" />
                        {{langConfig[lang].startGame}}
                    </span>
                    <span v-else>
                        <font-awesome-icon :icon="['fas', 'rotate-right']" />
                        {{langConfig[lang].playAgain}}
                    </span>
                </button>
            </div>
        </transition>

        <div class="grid-container">
            <div
                v-for="button in buttons" :key="button.id"
                :class="['button', 'button' + button.id, getButtonClass(button.id), isButtonBlinking(button.id), {'game-is-running': buttonsAreBlinking}]"
                @click="addToOrderOfInputs(button.id)">
                <div class="button-inner-circle"></div>
            </div>
        </div>
    </div>
</template>

<script>

import configLang from "../assets/config.json";

export default {
    props: ["timeToChangeRound", "lang"],
    data(){
        return {
            langConfig: configLang,
            gameIsRunning: false,
            round: 1,
            blinkingButton: false,
            buttonsAreBlinking: false,
            inputInProcess: false,
            randomButtonsArray: [],
            orderOfInputs: [],
            lastGameScore: false,
            highestGameScore: 0,
            buttons: [
                { id: 1 },
                { id: 2 },
                { id: 3 },
                { id: 4 },
                { id: 5 },
                { id: 6 },
                { id: 7 },
                { id: 8 },
                { id: 9 },
            ],
            apiUrl: "http://localhost:3000/api",
            startTime: 0,
            elapsedTime: 0,
            timer: null,
            timerRunning: false,
        }
    },
    computed: {
        score(){
            return this.round - 1;
        },
        level(){
            if(this.round <= 5){
                return 1;
            }else if(this.round <= 10){
                return 2;
            }else{
                return 3;
            }
        },
        availableButtons(){
            return this.level * 3;
        },
        availableButtonsIds(){
            const ids = [];

            for(let i = 1; i <= this.availableButtons; i++){
                ids.push(i);
            }

            return ids;
        },
        formatTime() {
            const minutes = Math.floor(this.elapsedTime / 60);
            const seconds = this.elapsedTime % 60;
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },
    },
    watch: {
        round(newRound){
            this.$emit('roundChange', newRound);
        },
        level(newLevel){
            this.$emit('levelChange', newLevel);

            this.startLearningModule(2);
        },
        lastGameScore(newLastGameScore){
            this.$emit("lastGameScore", newLastGameScore);
        },
        highestGameScore(newHighestGameScore){
            this.$emit("highestGameScore", newHighestGameScore)
        },
        formatTime(newFormatTime){
            this.$emit("formatTime", newFormatTime);
        },
        score(newScore){
            this.$emit("scoreChange", newScore);
        }
    },
    methods: {
        getButtonClass(buttonId) {
            if(this.level * 3 < buttonId) {
                return 'button-disabled';
            }

            return '';
        },
        isButtonBlinking(buttonId){
            if(this.blinkingButton === buttonId){
                return 'button-blink-' + buttonId;
            }else{
                return;
            }
        },
        async startGame(delay){
            let lection = false;
            if(!this.lastGameScore){
                lection = this.startLearningModule(0);
            }else{
                lection = this.startLearningModule(4);
            }

            if(lection){
                return false;
            }

            this.gameIsRunning = true;
            this.resetTimer();
            this.startTimer();
            if(delay){
                await this.delay(delay);
            }

            let gameContinues = true;
            let index = 0;

            while(gameContinues){
                if(index != 0){
                    await this.delay(this.timeToChangeRound);
                }

                let roundRes = await this.startRound();
                gameContinues = roundRes;
                index++;

                this.startLearningModule(1);
            }

            this.startLearningModule(3);

            this.stopTimer();

            this.resetGame();

            setTimeout(() => {
                this.gameIsRunning = false;
            }, this.timeToChangeRound + 300);
        },
        async startRound(){
            this.buttonsAreBlinking = true;
            let randomOrderOfButtons = await this.getRandomOrderOfButtons(this.round);  
            this.buttonsAreBlinking = false;

            let inputButtons = await this.getInputButtons(this.round);

            const areEqual = randomOrderOfButtons.length === inputButtons.length && randomOrderOfButtons.every((value, index) => value === inputButtons[index]);

            if(areEqual){
                this.round++;
                return true;
            }else{
                return false;
            }
        },
        async getRandomOrderOfButtons(){
            const randomIndex = Math.floor(Math.random() * this.availableButtonsIds.length);
            const randomItem = this.availableButtonsIds[randomIndex];

            this.randomButtonsArray.push(randomItem);

            for (const button of this.randomButtonsArray) {
                await this.blinkButton(button);
                await this.delay(50);
            }

            return this.randomButtonsArray;
        },
        blinkButton(buttonId){
            return new Promise((resolve) => {
                this.blinkingButton = buttonId;
                
                setTimeout(() => {
                    this.blinkingButton = false;
                    resolve();
                }, 1500);
            });
        },
        addToOrderOfInputs(buttonId){
            if(this.inputInProcess){
                this.orderOfInputs.push(buttonId);
            }
        },
        async getInputButtons(rounds){
            this.orderOfInputs = [];
            this.inputInProcess = true;

            while(this.orderOfInputs.length < rounds){
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            return this.orderOfInputs;
        },
        resetGame(){
            this.lastGameScore = this.round;

            if(this.highestGameScore === false){
                this.highestGameScore = this.round;
            }

            if(this.highestGameScore < this.round){
                this.highestGameScore = this.round;
            }

            this.round = 1;
            this.randomButtonsArray = [];
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        startTimer() {
            if (!this.timerRunning) {
                this.startTime = Math.floor(Date.now() / 1000) - this.elapsedTime;
                this.timer = setInterval(() => {
                this.elapsedTime = Math.floor(Date.now() / 1000) - this.startTime;
                }, 1000);
                this.timerRunning = true;
            }
        },
        stopTimer() {
            clearInterval(this.timer);
            this.timerRunning = false;
        },
        resetTimer() {
            this.elapsedTime = 0;
            this.startTime = Math.floor(Date.now() / 1000);
            if (this.timerRunning) {
                clearInterval(this.timer);
                    this.timer = setInterval(() => {
                    this.elapsedTime = Math.floor(Date.now() / 1000) - this.startTime;
                }, 1000);
            }
        },
        startLearningModule(index){
            if(this.$parent.module.modules[index].status != "success"){
                this.$parent.module.modules[index].status = "during";
                this.$parent.module.modules[index].isOpen = true;

                return true;
            }

            return false;
        }
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
}

</script>

<style lang="scss" scoped>

$button1: #FF2828;
$button2: #6889FF;
$button3: #00DD3E;
$button4: #FF72F9;
$button5: #f7d331;
$button6: #1DFAD2;
$button7: #FF9900;
$button8: #0029FF;
$button9: #9000C2;
$button-colors: $button1, $button2, $button3, $button4, $button5, $button6, $button7, $button8, $button9;

$lighten_by: 15%;
$darken_by: 5%;

.gaming-place{
    width: 100%;
    height: 100% !important;
    // position: relative;
}

.game-not-started{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: rgba(0, 0, 0, 0.795);

    border-radius: inherit;

    z-index: 2;

    display: flex;
    justify-content: center;
    align-items: center;
    
    button{
        background: #1272E9;
        color: #fff;
        border-radius: 10px;
        padding: 15px 20px;
        border: none;

        font-size: 32px;
        font-weight: 500;
    }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;

    height: 100%;
}

.button{
    width: 100%;
    height: 100%;
    background-color: #3498db;
    color: white;
    text-align: center;

    border-radius: 35px;
    position: relative;

    cursor: pointer;
}

.button-disabled:after{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: rgba(22, 22, 22, 1) !important;
    border-radius: 35px;
}

.button-disabled,
.game-is-running{
    pointer-events: none;
}

@for $i from 1 through length($button-colors) {
    .button#{$i} {
        background: nth($button-colors, $i);
        transition: .3s;

        &:not(.button-disabled){
            // border: 5px solid nth($button-colors, $i);

            &:hover{
                box-shadow: 0 0 30px nth($button-colors, $i);
            }
        
            &:active{
                // border: 2px solid ;
                background-color: darken(nth($button-colors, $i), $darken_by * 2); 
                box-shadow: 0 0 0px darken(nth($button-colors, $i), $darken_by);
            }
        }
    }

    // button blinking while showing order
    .button-blink-#{$i} {
        background: nth($button-colors, $i);
        position: relative;
        overflow: hidden;

        &:after{
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background: lighten(nth($button-colors, $i), $lighten_by);
            box-shadow: 0 0 30px lighten(nth($button-colors, $i), $lighten_by);
            animation: glowingButtonInnerCircle#{$i} 1s 1;
        }

        &:before{
            content: "";
            z-index: 1;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background: nth($button-colors, $i);
            box-shadow: 0 0 30px nth($button-colors, $i);
            animation: glowingButtonInnerCircle#{$i} 1s 1 .3s;
        }
    }
    
    @keyframes glowingButtonInnerCircle#{$i} {
        0% {
            width: 0;
            padding-top: 0;
        }
        100% {
            width: 200%;
            padding-top: 200%;
        }
    }
}

@media only screen and (max-width: 1000px){
    .grid-container {
        grid-gap: 20px;
    }
}

@media only screen and (max-width: 800px){
    .grid-container {
        grid-gap: 10px;
    }
}

</style>
